import OrderableModel from '@/models/OrderableModel';

export default class TicketType extends OrderableModel {
    get route () {
        return 'ticket-types';
    }

    static get className () {
        return 'TicketType';
    }

    static get isInStore () {
        return true;
    }
}
